import { render, staticRenderFns } from "./HeadGateway.vue?vue&type=template&id=164c8eaa&scoped=true"
import script from "./HeadGateway.vue?vue&type=script&lang=js"
export * from "./HeadGateway.vue?vue&type=script&lang=js"
import style0 from "./HeadGateway.vue?vue&type=style&index=0&id=164c8eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164c8eaa",
  null
  
)

export default component.exports